<ng-container>
    <div *ngIf="submission">
        <h3 class="form-header" mat-dialog-title i18n="@@SubmissionData" t="SubmissionData">Submission Data</h3>
        <div class="form-header" mat-dialog-title t="3340138088733673830" i18n="@@3340138088733673830"
            [tParams]="[name]">
            Submitted by : {{ name }}
        </div>
        <div class="form-header" mat-dialog-title>
            <span i18n="@@SubmissionDate" t="SubmissionDate">Submission Date</span> : {{ validationTask.date | date }}
        </div>
        <div class="form-header" mat-dialog-title t="5848216336646654843" i18n="@@5848216336646654843"
            [tParams]="[comment]">
            Submission Comment : {{ comment }}
        </div>
    </div>
    <div *ngIf="!submission">
        <h3 class="form-header" mat-dialog-title i18n="@@ReviewData" t="ReviewData">Review Data</h3>
        <div class="form-header" mat-dialog-title t="6654190153458093256" i18n="@@6654190153458093256"
            [tParams]="[name]">
            Review by : {{ name }}
        </div>
        <div class="form-header" mat-dialog-title>
            <span i18n="@@ReviewDate" t="ReviewDate">Review Date</span> : {{ date | date }}
        </div>
        <div class="form-header" mat-dialog-title t="7753938863395455571" i18n="@@7753938863395455571"
            [tParams]="[comment]">
            Review Comment : {{ comment }}
        </div>
    </div>
</ng-container>